import React from "react";
import { breadcrumbs } from "../../common/breadcrumbs";
import { TopBanner } from "../../common/TopBanner";
import { Link } from "../../lib/Link";

export const beginner_case2 = type => {
  document.title =
    "トランクルームをお探しなら『ハローストレージ』【公式】｜コレクション部屋";
  return (
    <div className="container">
      {breadcrumbs(type, [
        { href: "/beginner/", text: "初めての方へ" },
        { text: "コレクション部屋" },
      ])}
      
      <div className="beginner_contents_detail">
        <div className="main">
          <div id="width">
            <div className="sub">
              <img
                src="resource/img/static/beginner/beginner_case2.jpg"
                alt=""
                className="example"
              />
              <div className="frame1 pc">
                <h1>
                  コレクション部屋
                  <span>大好きなものたちに囲まれて</span>
                </h1>
                <p>
                  プラモデル、ミニカー、モデルガンなど、自宅に保管しているコレクション達をトランクルームにディスプレイすれば、この世でたった一つの、あなた専用ショールームができあがり。
                  <br />
                  空調つきの物件もご用意していますので、
                  <br />
                  大切なコレクションを安全に収納することができます。
                </p>
              </div>
              <div className="frame1 sp">
                <h1>コレクション部屋</h1>
                <p>大好きなものたちに囲まれて</p>
              </div>
              <div className="sp">
                <p>
                  プラモデル、ミニカー、モデルガンなど、自宅に保管しているコレクション達をトランクルームにディスプレイすれば、この世でたった一つの、あなた専用ショールームができあがり。
                  <br />
                  空調つきの物件もご用意していますので、大切なコレクションを安全に収納することができます。
                </p>
              </div>
            </div>
            <div className="cases1 cases">
              <img
                src="resource/img/static/beginner/beginner_case2_1.jpg"
                alt=""
                className="sample"
              />
              <div className="text-box">
                <h1>家では置けないたくさんの在庫
                <br className="pc" />
                気にせず展示しませんか？</h1>
                <p>
                  末永く大切にしたい。
                  <br className="pc" />
                  けれど自宅の隅で平積みにされたままの書籍たち。
                  <br className="pc" />
                  スチールラックや棚と一緒に収納すると、
                  <br className="pc" />
                  トランクルームが便利な本棚へ大変身。
                </p>
              </div>
              <br clear="left pc" />
            </div>
            <div className="cases2 cases">
              <img
                src="resource/img/static/beginner/beginner_case2_2.jpg"
                alt=""
                className="sample"
              />
              <div className="text-box">
                <h1>奥さん、旦那さんに言えない
                <br className="pc" />
                趣味の物も</h1>
                <p>
                  トランクルーム一面に本や趣味のアイテムを並べてみましょう。
                  <br className="pc" />
                  思わず長居したくなる、
                  <br className="pc" />
                  あなた専用の書斎を自宅の外に構えることができます。
                </p>
              </div>
              <br clear="right pc" />
            </div>
            <div className="cases3 cases">
              <img
                src="resource/img/static/beginner/beginner_case2_3.jpg"
                alt=""
                className="sample"
              />
              <div className="text-box">
                <h1>バンド活動や趣味にて仲間と
                <br className="pc" />
                共有してわくわくする場所に</h1>
                <p>
                  大事な洋服を押し入れに詰め込むのではなく、
                  <br className="pc" />
                  ハンガーにかけてトランクルームをもう１つの
                  <br className="pc" />
                  ウォークローゼットに。
                  <br className="pc" />
                  シーズンやシーンごとにお気に入りの一着に着替えて
                  <br className="pc" />
                  街へ繰り出しましょう。
                </p>
              </div>
              <br clear="left pc" />
            </div>
            <Link to="/list/" className="finding">
              いますぐ探す
            </Link>
            <div className="background">
              <h2>その他の利用シーン</h2>
            </div>
            <div className="others pc">
              <Link to="/beginner/case1/">
                <img
                  src="resource/img/static/beginner/beginner_case1.jpg"
                  alt=""
                  className="example"
                />
              </Link>
              <Link to="/beginner/case3/">
                <img
                  src="resource/img/static/beginner/beginner_case3.jpg"
                  alt=""
                  className="example"
                />
              </Link>
              <div className="frame2">
                <Link to="/beginner/case1/" className="frame">
                  <h1>見せる収納</h1>
                  <p>思い出をインテリアのように楽しむ</p>
                </Link>
              </div>
              <div className="frame3">
                <Link to="/beginner/case3/" className="frame">
                  <h1>ひみつ基地</h1>
                  <p>アクティビティの中継基地に大活躍</p>
                </Link>
              </div>
            </div>
            <div className="others sp">
              <Link to="/beginner/case1/">
                <img
                  src="resource/img/static/beginner/beginner_case1.jpg"
                  alt=""
                  className="example"
                />
                <div className="frame2">
                  <h1>見せる収納</h1>
                  <p>思い出をインテリアのように楽しむ</p>
                </div>
              </Link>
            </div>
            <div className="others sp">
              <Link to="/beginner/case3/">
                <img
                  src="resource/img/static/beginner/beginner_case3.jpg"
                  alt=""
                  className="example"
                />
                <div className="frame3">
                  <h1>ひみつ基地</h1>
                  <p>アクティビティの中継基地に大活躍</p>
                </div>
              </Link>
            </div>
            <div className="information">
              <div className="pc">
                <Link to="/lineup/" className="textArea">
                  <img src="resource/img/static/beginner/lineup.png" />
                  <span>
                    商品ラインナップは
                    <br />
                    こちら
                  </span>
                </Link>
                <Link to="/flow/" className="textArea">
                  <img src="resource/img/static/beginner/flow.png" />
                  <span>
                    お申し込みから
                    <br />
                    ご契約の流れまで
                  </span>
                </Link>
                <Link to="/voice2/" className="textArea">
                  <img src="resource/img/static/beginner/voice.png" />
                  <span>
                    実際の
                    <br />
                    お客様の声
                  </span>
                </Link>
              </div>
              <div className="sp">
                <Link to="/lineup/" className="text1">
                  <img src="resource/img/static/beginner/lineup_sp.png" />
                  <span>
                    商品ラインナップは
                    <br />
                    こちら
                  </span>
                </Link>
                <Link to="/flow/" className="text2">
                  <img src="resource/img/static/beginner/flow_sp.png" />
                  <span>
                    お申し込みから
                    <br />
                    ご契約の流れまで
                  </span>
                </Link>
                <Link to="/voice2/" className="text3">
                  <img src="resource/img/static/beginner/voice_sp.png" />
                  <span>
                    実際の
                    <br />
                    お客様の声
                  </span>
                </Link>
              </div>
              <br className="left" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./pages/new/beginner_case2.jsx